export default __webpack_public_path__ + "static/gw2-banner-into-tyria-15a1dc918c98b370622144a50c78bddc.png";